import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/Reports/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import { StaffList } from '@C/Utils';
import { PaymentMethodInfo } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

import ExpenseList from '../../../Utils/ExpenseList';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Expense Source',
    key: 'payment_for',
    formatter(props) {
      return <>{props.source}</>;
    },
  },
  {
    name: 'Added By',
    key: 'cashier',
    formatter(props) {
      return <>{`${props.first_name} ${props.last_name}`}</>;
    },
  },
  {
    name: 'Payment mode',
    key: 'payment_method',
    formatter(props) {
      return (
        <>
          <PaymentMethodInfo
            source={props.source}
            method={props.payment_method}
            bank={props.bank}
            wallet={props.other_wallet}
          />
        </>
      );
    },
  },
  {
    name: 'Amount',
    key: 'payment_for',
    formatter(props) {
      return <>{formatCurrency(props.payment_details.amount)}</>;
    },
    type: 'currency',
  },
  {
    name: 'Tax',
    key: 'payment_for',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.payment_details.tax)}</>;
    },
  },
  {
    name: 'Total Amount',
    key: 'payment_for',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.payment_details.after_tax)}</>;
    },
  },
  {
    name: 'Notes',
    key: 'notes',
  },
];

class ExpenseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      product_id: '',
      staff_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getOtherExpenseReport();
  }

  handleExpenseChange = (e) => {
    this.setState({ product_id: e?.value || '' });
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  getOtherExpenseReport = () => {
    services
      .getExpenseReport(this.state)
      .then((response) => {
        this.setState({
          slipList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getOtherExpenseReport();
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getOtherExpenseReport();
    });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        loading: true,
        product_id: '',
        staff_id: '',
        limit: 20,
        offset: 1,
      },
      function () {
        this.getOtherExpenseReport();
      },
    );
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getOtherExpenseReport();
    });
  };

  render() {
    const { slipList } = this.state;
    const exportOptions = {
      fileName: `Other Expense - ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Other Expense Report',
      reportDate: `Date - ${dayjs(this.state.start_date).format(
        'D MMM YY',
      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
      reportTotal: `Total amount -  ${
        slipList
          .reduce(
            (a, b) =>
              a + (b['payment_for']['payment_details']['after_tax'] || 0),
            0,
          )
          .toFixed(2) || 0
      }`,
      reportQuantity: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
      reportSales: '',
      reportTesting: '',
      reportBowser: '',
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
    };
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <div className="stock-info-headers">
            <h3>Expense Report ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total amount: </span>
                  <span>
                    {formatCurrency(
                      slipList.reduce(
                        (a, b) =>
                          a +
                          (b['payment_for']['payment_details']['after_tax'] ||
                            0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>

              <div className="filter-group">
                <label>Expense Source:</label>
                <ExpenseList
                  value={this.state.product_id}
                  onChange={this.handleExpenseChange}
                  isShowDeleted={true}
                />
              </div>
              <div className="filter-group">
                <label>Added By:</label>
                <StaffList
                  value={this.state.staff_id}
                  onChange={this.handleStaffChange}
                  staffType={['Cashiers', 'Managers', 'Dealer']}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={slipList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: `Other Expense - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Other Expense Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format(
                        'D MMM YY',
                      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total amount -  ${
                        slipList
                          .reduce(
                            (a, b) =>
                              a +
                              (b['payment_for']['payment_details'][
                                'after_tax'
                              ] || 0),
                            0,
                          )
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { ExpenseReport };
